module.exports = __webpack_public_path__ + "static/media/posicao_amamentar5.75d9953a.jpg";